import { UnsetVmwareIntegratorWebComponent } from './component/UnsetVmwareIntegratorWebComponent';

export { UnsetVmwareIntegratorWebComponent };
